import { Validators } from "@angular/forms";
import { FormType, Properties, SepiaProperties } from "../properties.model";
import { EffectsType } from "../ui-effects.model";

export const sepiaForm: Properties = {
  propertyType: EffectsType.Sepia,
  label: 'Sepia',
  forms: [
    {
      id: SepiaProperties.SepiaStrength,
      label: 'Sepia Strength',
      type: FormType.SliderNumber,
      defaultValue: 1,
      validators: [Validators.required],
      sliderOptions: {
        min: 0,
        max: 1,
        step: 0.01
      },
    },
  ],
  changeHandler: () => {}
}
